import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { CloudDownload, ErrorOutline, Print } from "@mui/icons-material";
import { Box, Button, Card, FormLabel, Grid, Icon, MenuItem, TextField, styled } from "@mui/material";
import { Loader } from "app/components";
import { getAllCostIndexRateForDateWise, getAllWorkTypeList, getAllWorkTypeListByConstructionNameId } from "app/redux/actions/ConstIndexActions";
import { getAllConstructionNameListByParameters, getAllProjectLocationListForReports } from "app/redux/actions/ProjectLocationActions";
import { getCostIndexReport } from "app/redux/actions/ReportsAction";
import { AppConstants } from "app/utils/AppConstants";
import { ServiceUrl } from 'app/utils/Constants';
import { SnackBarProperty } from "app/utils/SnackBarProperty";
import { checkValidation, currencyFormat, formatDate, formatNumberWithCommasAndDecimals } from "app/utils/utils";
import { SimpleCard } from "components";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import moment from "moment";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";



const DecoratedTextField = styled(TextValidator)(() => ({
  width: "100%",
  marginBottom: "16px",
}));




export const CostIndexReport = ({param}) => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { workTypeList } = useSelector((state) => state.costIndex);
  const [isDownloading, setIsDownloading] = useState(false)
  const [isPrinting, setIsPrinting] = useState(false)
  const [projectDetails, setProjectDetails] = useState()
  const [tableData, setTableData] = useState()
  
  const [state, setState] = useState({
    project_location_id: '',
    construction_name:'',
    work_type:"",
    constructionname_id: '',
    costindex_percent:"",
    costindex_date:"",
    worktype_id:""
  })

  useEffect(()=>{
      setState({...state, ['project_location_id']: param.project_location_id, 
                          ['constructionname_id']: param.constructionname_id
      })
      dispatch(getAllWorkTypeListByConstructionNameId(param.constructionname_id, showLoader, hideLoader, showToast))
  },[param])


  const showLoader = () => {
    setLoading(true)
  }

  const showToast = (msg) => {
    const key = enqueueSnackbar(msg ?? AppConstants.somethingWentWrong, { variant: 'error' });
    SnackBarProperty.error(key, closeSnackbar);
  }

  const hideLoader = () => {
    setLoading(false)
  }

  const handleChangeCostIndexDate = (event, source) => {
    const filteredArray = workTypeList.filter(workType => {
        return workType.worktype_id === event.target.value
      });
      setState({ ...state, ["costindex_percent"]: filteredArray[0]?.costindex_percent,
                          ["project_location"]: filteredArray[0]?.projectLocation?.project_location,
                          ["project_name"]: filteredArray[0]?.projectLocation?.project_name,
                          ["project_id"]: filteredArray[0]?.projectLocation?.project_id,
                          ["construction_name"]: filteredArray[0]?.construction_name,
                           ["worktype_id"]: filteredArray[0]?.worktype_id,
                           [event.target.name]: filteredArray[0]?.worktype_date });
  }

  const handleFormSubmit = () => {
    if (!checkValidation(state?.costindex_date)) {
      const key = enqueueSnackbar("Please select cost index date", { variant: 'error' });
      SnackBarProperty.error(key, closeSnackbar);
    } else {   
      setLoading(true)
      const params = { worktype_id: state?.worktype_id, created_on: state?.costindex_date }
      getCostIndexReport(params)
        .then((res) => {
          setLoading(false)

          if (res?.status < 300 && res?.data?.success) {
            const tableDataList = res?.data?.obj?.item
            setProjectDetails({
              header: res?.data?.obj?.header_logo,
              footer: res?.data?.obj?.footer_logo
            })
            setTableData(tableDataList)
          } else {
              const key = enqueueSnackbar(res?.data?.message, { variant: 'error' });
              SnackBarProperty.error(key, closeSnackbar);
          }
        }).catch(error => {
          setLoading(false)
          const key = enqueueSnackbar(error?.response?.data?.errorMessage ?? AppConstants.somethingWentWrong, { variant: 'error' });
          SnackBarProperty.error(key, closeSnackbar);
      })}
  }

  const handleDownload = (isPrint) => {
    if (isPrint) {
      setIsPrinting(true)
      setIsDownloading(false)
    }
    else {
      setIsPrinting(false)
      setIsDownloading(true)
    }
    const doc = new jsPDF();


      // Adjust the value for vertical separation
      const headerHeight = checkValidation(projectDetails?.header) ? 35 : 15
      const textX = 15;
      const textY = headerHeight
      const textWidth = doc.getStringUnitWidth("Project Location:") * doc.internal.getFontSize() / doc.internal.scaleFactor;
      // Add the text content below the header image
      doc.setFont('helvetica', 'bold'); // Set font to bold
      doc.setFontSize(12); // Set font size
      //doc.text(`Bill of Quantities (${reportType === "estimate" ? "Estimate" : "Contract"})`, textX, textY);
      doc.setFontSize(8); // Set font size
      doc.text("Project Location:", textX, textY + 10);
      doc.setFont('helvetica', 'normal');
      doc.text(state?.project_location, textX + textWidth + 5, textY + 10);
      doc.setFont('helvetica', 'bold');
      doc.text("Project Name:", textX, textY + 15);
      doc.setFont('helvetica', 'normal');
      doc.text(state?.project_name, textX + textWidth + 5, textY + 15);
      doc.setFont('helvetica', 'bold');
      doc.text("Project ID:", textX, textY + 20);
      doc.setFont('helvetica', 'normal');
      doc.text(`${state?.project_id}`, textX + textWidth + 5, textY + 20);
      doc.setFont('helvetica', 'bold');
      doc.text("Construction Name:", textX, textY + 25);
      doc.setFont('helvetica', 'normal');
      doc.text(`${state?.construction_name}`, textX + textWidth + 5, textY + 25);

      doc.setFont('helvetica', 'bold');
      doc.text("Work Type:", textX, textY + 30);
      doc.setFont('helvetica', 'normal');
      doc.text(`${state?.work_type}`, textX + textWidth + 5, textY + 30);

      doc.setFont('helvetica', 'bold');
      doc.text("Cost Index Date:", textX, textY + 35);
      doc.setFont('helvetica', 'normal');
      doc.text(`${formatDate(state?.costindex_date)}`, textX + textWidth + 5, textY + 35);

      doc.setFont('helvetica', 'bold');
      doc.text("Cost Index (%):", textX, textY + 40);
      doc.setFont('helvetica', 'normal');
      doc.text(`${state?.costindex_percent}`, textX + textWidth + 5, textY + 40);

      const headerSectionHeight = headerHeight + 35; // Adjust the value as needed

      // Calculate the starting Y-coordinate for the table
      const tableStartY = headerSectionHeight + 5;
      doc.setFont('helvetica', 'normal');
const body=[]
      tableData?.forEach((item,index) => {

          body.push([
            {content:index + 1, styles: { fontSize:8 }},
            {content:item?.item_code, styles: { fontSize:8 }},
            {content:item?.description, styles: { fontSize:8 }},
            {content:item?.unit_name, styles: { fontSize:8 }},
            { content: formatNumberWithCommasAndDecimals(item?.weightage), styles: { fontSize:8 }},
            { content: formatNumberWithCommasAndDecimals(item?.cost_baselocation??0), styles: { halign: "right",fontSize:8 } },
            { content: formatNumberWithCommasAndDecimals(item?.cost_projectlocation??0), styles: { halign: "right",fontSize:8 } },
            { content: formatNumberWithCommasAndDecimals(item?.percentage_increase??0), styles: { halign: "right",fontSize:8 } },
            { content: formatNumberWithCommasAndDecimals(item?.costindex_percent??0), styles: { halign: "right",fontSize:8 } },
          ])
      })

      doc.autoTable({
         margin: { 
          top: 30,      // push below header
          bottom: 30    // leave space above footer
        },
        startY: tableStartY,
        head: [[
          { content: "Sl No.", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Item Code", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Description", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Unit", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Weightage", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Base Location Rate", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Project Location Rate", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Percentage Increase", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } },
          { content: "Cost Index (%)", colSpan: 1, styles: { valign: "middle", halign: "center", cellPadding: 2, fontSize: 8 } }
        ]],
        body: body, // Use the transformed data here
        theme: "grid",
        styles: {
          fillColor: [255, 255, 255], // Remove background color from the table
          lineColor: [0, 0, 0], // Set border color for main table
          lineWidth: 0.1, // Set border width for main table
          textColor: [0, 0, 0], // Set text color to black
          cellPadding: 2, // Add padding to cells
        },
        columnStyles: {
          2: { cellWidth: 50 }, // "ITEM DESCRIPTION" column width
          5: { halign: "right" }, // "RATE" column width
          6: { halign: "right" }, // "AMOUNT" column width
          3: { halign: "right" }, // "UNIT" column width
        },
      });

      const totalNumPages = doc.internal.getNumberOfPages();

      // Loop through each page to add the footer with page numbers
      for (let i = 1; i <= totalNumPages; i++) {
  
        const pdfWidth = doc.internal.pageSize.getWidth() - 30;
  
        // Header
        const headerHeight = 20;
        const headerX = 15;
        const headerY = 0; // at the very top
        if (checkValidation(projectDetails?.header)) {
          doc.addImage(
            `${ServiceUrl?.showImageUrl}${projectDetails?.header}`,
            headerX,
            headerY,
            pdfWidth,
            headerHeight
          );
        }
  
        //Footer
        const footerX = 15; // Starting X position for the footer
        const footerY = doc.internal.pageSize.getHeight() - 20; // 10 units from the bottom
        const footerHeight = 20;
        doc.setPage(i);
        if (checkValidation(projectDetails?.footer)) {
          doc.addImage(`${ServiceUrl?.showImageUrl}${projectDetails?.footer}`, footerX, footerY, pdfWidth, footerHeight)
        }
      }


      const scaleFactor = 1.0; // Adjust this value as needed
      const pdfBlob = doc.output('blob', { scale: scaleFactor });

      // Create a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);

      // Open a new window with the PDF URL

      if (isPrint) {
        const newWindow = window.open(pdfUrl, '_blank');

        // After the new window is opened, you can close the URL object
        URL.revokeObjectURL(pdfUrl);
        if (newWindow) {
          newWindow.onload = () => {
            setIsPrinting(false)
            setIsDownloading(false)
            // Wait for the window to load and then trigger the print dialog
            newWindow.print();
          };
        }
      }

      setIsPrinting(false)
      setIsDownloading(false)

      isPrint === false && doc.save('Cost_Index_Report.pdf');
  };

  return (
    <>
      <div style={{ height: 'auto', width: "100%", display: "flex", flexDirection: "column", gap: "20px" }}>
        <SimpleCard>
          <ValidatorForm onSubmit={handleFormSubmit}>
            <Grid container spacing={3} style={{ marginTop: '-45px', marginBottom: '15px' }} >
              <Grid item xs={12}><b className="font20 extraBold" style={{ color: "#ebad4e" }}>Cost Index Details</b></Grid>
            </Grid>

            <Grid container spacing={3} >
              <Grid item sm={3} xs={12}>

                <DecoratedTextField
                  size="small"
                  select
                  type="text"
                  name="costindex_date"
                  label="Cost Index Date(s)"
                  value={state?.worktype_id}
                  onChange={handleChangeCostIndexDate}
                  validators={["required"]}
                  errorMessages={["Cost Index Date is required"]}>
                  {workTypeList?.map((item) => (
                    <MenuItem key={item?.worktype_date} value={item?.worktype_id}>
                        {formatDate(item?.worktype_date)}
                    </MenuItem>
                ))}
                </DecoratedTextField>
              </Grid>
              <Grid item sm={3} xs={12}>
                <Button size="medium" color="success" variant="contained" type="submit" style={{ marginLeft: 4 }} >View</Button>
              </Grid>
            </Grid>
          </ValidatorForm>
        </SimpleCard>
        {tableData && tableData?.length > 0 && <Grid container>
          <Grid xs={12} md={6}>
            {/* {checkValidation(projectDetails?.header)===false&&<FormLabel sx={{color:"#ff9800"}} color="warning">! Please upload header and footer for download/print</FormLabel>} */}
            </Grid>
          <Grid item xs={12} md={6}>
            <Box component="span" display="flex" justifyContent="flex-end">
              <Button
                size="small"
                // disabled={projectDetails?.header?false:true}
                sx={{ width: "130px", marginLeft: 4 }}
                variant="contained"
                color="warning"
                startIcon={<CloudDownload />}
                onClick={() => { handleDownload(false) }}
              >
                Download
              </Button>
              <Button
                size="small"
                sx={{ width: "100px", marginLeft: 2 }}
                variant="contained"
                color="primary"
                // disabled={projectDetails?.header?false:true}
                startIcon={<Print />}
                onClick={() => { handleDownload(true) }}
              >
                Print
              </Button>
            </Box>
          </Grid>

        </Grid>}
        {tableData && tableData?.length > 0 && <Card sx={{ padding: 3 }}>

          <div style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px" }}>
            <div id="header" style={{ width: "100%", display: 'flex', flexDirection: "column", gap: "50px", paddingLeft: "100px", paddingRight: "100px" }}>
              <div style={{ width: "100%", display: "flex", justifyContent: "center", gap: "20px", alignItems: "center" }}>
                {checkValidation(projectDetails?.header) && 
                  <img id="headerLogo" src={`${ServiceUrl?.showImageUrl}${projectDetails?.header}`} style={{ height: "150px", width: "auto" }} alt="img" />
                }
              </div>

              <Grid container spacing={0} >
                <Grid item xs={12} align='center' >
                  <FormLabel sx={{ fontSize: 22 }} ><b>Cost Index Report</b></FormLabel>
                </Grid>

                <Grid item xs={12} sx={{ marginTop: 2 }}>
                  <FormLabel sx={{ fontSize: 18 }}><b>Project Location: </b>{state?.project_location}</FormLabel>
                </Grid>
                <Grid item xs={12} >
                  <FormLabel sx={{ fontSize: 18 }}><b>Project Name: </b>{state?.project_name}</FormLabel>
                </Grid>
                <Grid item xs={12} >
                  <FormLabel sx={{ fontSize: 18 }}><b>Project ID: </b>{state?.project_id}</FormLabel>
                </Grid>
                <Grid item xs={12} >
                  <FormLabel sx={{ fontSize: 18 }}><b>Construction Name: </b>{state?.construction_name}</FormLabel>
                </Grid>
                <Grid item xs={12} >
                  <FormLabel sx={{ fontSize: 18 }}><b>Cost Index Date: </b>{formatDate(state?.costindex_date)}</FormLabel>
                </Grid>
                <Grid item xs={12} >
                <FormLabel sx={{ fontSize: 18 }}><b>Cost Index(%): </b>{currencyFormat(state?.costindex_percent)}</FormLabel>
                </Grid>
              </Grid>
            </div>

            <div id="tableData">
              <TableContainer component={Paper}>
                {/* <Table>
                  <TableHead>
                    <TableRow align='center'>
                      <FormLabel sx={{ fontSize: 22 }}><b>Bill of Quantities</b></FormLabel>
                    </TableRow>
                    <TableRow>
                      <TableCell><b>Project Name: </b>{projectDetails?.project_name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><b>Construction Name: </b>{projectDetails?.construction_name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><b>Dzongkhag: </b>{projectDetails?.dzongkhag_name}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell><b>BSR Year: </b>{projectDetails?.dzongkhag_name}</TableCell>
                    </TableRow>
                  </TableHead>
                </Table> */}

                <Table>
                  <TableHead style={{ backgroundColor: '#87CEEB' }}>

                    <TableRow>
                      <TableCell>Sl No.</TableCell>
                      <TableCell>Item Code</TableCell>
                      <TableCell>Description</TableCell>
                      <TableCell>Unit</TableCell>
                      <TableCell align='right'>Weightage</TableCell>
                      <TableCell align='right'>Base Location Rate</TableCell>
                      <TableCell align='right'>Project Location Rate</TableCell>
                      <TableCell align='right'>Percentage Increase</TableCell>
                      <TableCell align='right'>Cost Index (%)</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData?.map((data,index) => (
                      
                        <TableRow>
                          <TableCell>{index+1}</TableCell>
                          <TableCell>{data?.item_code}</TableCell>
                          <TableCell>{data?.description}</TableCell>
                          <TableCell>{data?.unit_name}</TableCell>
                          <TableCell align='right'>{formatNumberWithCommasAndDecimals(data?.weightage??0)}</TableCell>
                          <TableCell align='right'>{formatNumberWithCommasAndDecimals(data?.cost_baselocation??0)}</TableCell>
                          <TableCell align='right'>{formatNumberWithCommasAndDecimals(data?.cost_projectlocation??0)}</TableCell>
                          <TableCell align='right'>{formatNumberWithCommasAndDecimals(data?.percentage_increase??0)}</TableCell>
                          <TableCell align='right'>{formatNumberWithCommasAndDecimals(data?.costindex_percent??0)}</TableCell>
                        </TableRow>
                     

                     
                    ))}
                    {/* <TableRow>
                      <TableCell colSpan={6} align="right" style={{ fontWeight: 600 }}><b>Total Amount</b></TableCell>
                      <TableCell colSpan={1} style={{ fontWeight: 600 }} align="right"><b>{formatNumberWithCommasAndDecimals(totalAmount)}</b></TableCell>
                    </TableRow> */}
                  </TableBody>
                </Table>
              </TableContainer>

            </div>
          </div>
        </Card>}
  
      </div>
      {loading && (
        <Loader
          show={loading}
        />
      )}
      {(isPrinting || isDownloading) && (
        <Loader
          show={isPrinting ? isPrinting : isDownloading}
          text="Processing...Please wait."
        />
      )}

    </>
  )
}